<template>
  <form class="container-fluid body">
    <div class="container">
      <div class="header_placement">
        <h2 style="color:#0892D0;">Arnergy Lux Devices</h2>
        <p>{{ this.$store.state.luxCount }} of 2</p>
      </div>
      <!-- DeviceSerial -->
      <div v-if="this.$store.state.luxCount == 1">
        <DeviceSerial />
      </div>
      <!-- LuxPayment -->
      <div v-else-if="this.$store.state.luxCount == 2">
        <LuxPayment />
      </div>
    </div>
  </form>
</template>

<script>
import DeviceSerial from "./DeviceSerial.vue";
import LuxPayment from "./LuxPayment.vue";
import LuxMisc from "./LuxMisc.vue";
export default {
  name: "LuxOnboarding",
  data() {
    return {};
  },
  components: {
    DeviceSerial,
    LuxPayment,
    LuxMisc
  },
  methods: {}
};
</script>

<style scoped>
.body {
  background-color: whitesmoke;
  height: 100%;
  padding: 6% 0 12%;
  margin: 24px 0;
}
.container {
  width: 75%;
  margin: auto;
  background-color: #ffffff;
  border-radius: 18px;
  box-shadow: 0 0px 10px 0 rgb(34 40 53 / 74%), 0 0px 0px 0 rgb(55 194 48 / 19%);
}
.header_placement {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 70%;
  font-family: sans-serif;
  width: 100%;
  margin: auto;
  padding: 6px 0;
}
.header_placement p {
  margin: 20px 0 !important;
}
.button_style {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 70%;
  font-family: sans-serif;
  width: 100%;
  margin: auto;
  padding: 24px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/LuxOnboarding.vue